import templateIds from '../../../constants/templates.constants';
import { TLinkField, TStringField } from '../../../types/types';
import { TInteractiveImageFields, TInteractiveImageMblDeskItemField, TInteractiveImageProps } from '../types/interactiveImage.types';

export class InteractiveImageModel {
  private readonly fields: TInteractiveImageFields | undefined;

  constructor(props: TInteractiveImageProps) {
    this.fields = props?.fields || {};
  }

  get eyebrow(): TStringField | undefined {
    return this.fields?.optionalEyebrow;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get description(): TStringField | undefined {
    return this.fields?.description;
  }

  get primaryLink(): TLinkField | undefined {
    return this.fields?.hotspotLink;
  }

  get isPrimaryLinkExists(): boolean {
    return !!(this.primaryLink?.value?.href && this.primaryLink?.value?.text);
  }

  mblDeskItem(isWide: boolean): TInteractiveImageMblDeskItemField {
    const templateIdOfField = isWide ? templateIds['interactiveImage']['dskHotspotId'] : templateIds['interactiveImage']['mblHotspotId'];
    return this.fields?.items?.find((_) => _.fields?.templateId === templateIdOfField)?.fields || {};
  }
}
